import {ListPage} from "../../common/ListPage";
import {RouteContext} from "../../../RouteContext";
import {Column} from "../../common/Layout";
import {HttpClient} from "../../../../io/HttpClient";
import {ShoppingFunnelValueObject} from "../../../../model/vo/content/ShoppingFunnelValueObject";
import {ShoppingFunnelIO} from "../../../../io/content/ShoppingFunnelIO";


export default function List(props: RouteContext) {

    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={ShoppingFunnelValueObject.description}
                list={ShoppingFunnelIO.list}
                count={ShoppingFunnelIO.count}
                delete={ShoppingFunnelIO.delete}
                postHref={'/admin/shoppings/funnels/post'}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
                initialSortOrders={[
                    {
                        name: 'exposedAt',
                        order: 'DESC'
                    }
                ]}
                detailHref={item => `/admin/shoppings/funnels/${item.id}`}
                editHref={item => `/admin/shoppings/funnels/edit/${item.id}`}
                downloadSheetUrl={(searchConditions, sortOrders, offset,count) =>
                    HttpClient.buildUrl(
                        `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/funnel/excel`,
                        searchConditions,
                        sortOrders,
                        count,
                        offset,
                    )}
            />
        </Column>
    </>
}